const HeroSection = () => {
  return (
    <section className="relative h-[400px] lg:h-[500px] flex items-center justify-center overflow-hidden">
      {/* Background Gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#007bbb] via-[#0099dd] to-[#00aaee]"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-6">
        <span className="text-white/90 text-xs font-semibold tracking-widest uppercase">CONTACT</span>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mt-4 leading-tight">
          お問い合わせ
        </h1>
        <p className="text-white/90 text-lg md:text-xl mt-6 max-w-2xl mx-auto">
          ご予約・ご相談はお気軽にお問い合わせください
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
